<template>
  <div class="border p-2 rounded">
    <div class="row">
      <div class="col-11">
        <input
            v-model="data.title"
            class="form-control mb-2"
            placeholder="Заголовок"
        />
      </div>
      <div class="col-1">
        <button
            class="btn btn-icon"
            @click="collapsed = !collapsed"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-arrows-sort"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 9l4 -4l4 4m-4 -4v14" /><path d="M21 15l-4 4l-4 -4m4 4v-14" /></svg>
        </button>
      </div>
    </div>

    <div v-show="!collapsed">
      <textarea
          v-model="data.text"
          class="form-control"
          rows="12"
          placeholder="Текст"
      ></textarea>
    </div>

  </div>
</template>

<script setup>
import { reactive, watch, onMounted, ref } from 'vue'
import { debounce } from 'lodash'

const emit = defineEmits(['onUpdate'])
const props = defineProps({ payload: Object })

const data = reactive({ title: '', text: '' })
const collapsed = ref(false)     // <-- состояние свернуто/развернуто

onMounted(() => {
  Object.assign(data, props.payload.data || {})
  emitUpdate()
})

const emitUpdate = debounce(() => {
  emit('onUpdate', {
    type: 'text',
    data: { ...data }
  })
}, 300)

watch(data, emitUpdate, { deep: true })
</script>
